import { Navigate } from 'react-router-dom';

export default function BatchCreationGuidePage() {
  return <Navigate to="/products/create-batch#create-new-batch-section" replace />;
}
